function About() {
    return (
        <>
            <h1>Hello from Aboutpage</h1>
        </>
    );
}

export default About;
